import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import HomeLanding from "../views/HomeLanding";

export default function Home() {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	useEffect(() => {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			setView(<HomeLanding/>);
		} else {
			setView(null);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}
